import type { TabsDesignTokens, TabsTokenSections } from '@primeuix/themes/types/tabs';

export const root: TabsTokenSections.Root = {
    transitionDuration: '{transitionDuration}'
};

export const tablist: TabsTokenSections.Tablist = {
    borderWidth: '0 0 1px 0',
    background: 'transparent',
    borderColor: '{content.borderColor}'
};

export const tab: TabsTokenSections.Tab = {
    background: 'transparent',
    hoverBackground: 'transparent',
    activeBackground: 'transparent',
    borderWidth: '0 0 2px 0',
    borderColor: 'transparent',
    hoverBorderColor: 'transparent',
    activeBorderColor: '{primary.color}',
    color: '{grey.600}',
    hoverColor: '{sand.950}',
    activeColor: '{primary.600}',
    padding: '12px 16px',
    fontWeight: '600',
    margin: '0',
    gap: '8px',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    }
};

export const tabpanel: TabsTokenSections.Tabpanel = {
    background: 'transparent',
    color: '{content.color}',
    padding: '0.875rem 0 0 0',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    }
};

export const navButton: TabsTokenSections.NavButton = {
    background: '{content.background}',
    color: '{content.color}',
    hoverColor: '{content.hoverColor}',
    width: '2.5rem',
    focusRing: {
        width: '{focusRing.width}',
        style: '{focusRing.style}',
        color: '{focusRing.color}',
        offset: '{focusRing.offset}',
        shadow: '{focusRing.shadow}'
    },
    shadow: '{overlay.navigation.shadow}'
};

export const activeBar: TabsTokenSections.ActiveBar = {
    height: '2px',
    bottom: '-1px',
    background: '{primary.color}'
};

export const colorScheme: TabsTokenSections.ColorScheme = {
    light: {
        navButton: {
            shadow: '0px 0px 10px 50px rgba(255, 255, 255, 0.6)'
        }
    },
    dark: {
        navButton: {
            shadow: '0px 0px 10px 50px color-mix(in srgb, {surface.900}, transparent 50%)'
        }
    }
};

export default {
    root,
    tablist,
    tab,
    tabpanel,
    navButton,
    activeBar,
    colorScheme
} satisfies TabsDesignTokens;
